import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { GlobalSearch } from "@/components/layout/GlobalSearch";

export const AppShell = () => {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-paper">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-[52px] shrink-0 items-center border-b border-line bg-paper px-6">
          <GlobalSearch />
        </div>
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden" data-testid="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
